/** DOM id for the sidebar bell — must match `trigger` on `<released-widget />`. */
export const RELEASED_CHANGELOG_TRIGGER_ID = 'released-changelog-trigger'

/** Default channel when `RELEASED_CHANNEL_ID` is unset (MyAssetMap Released portal). */
export const RELEASED_DEFAULT_CHANNEL_ID =
  'b825d3e4-5ca8-41b8-92db-99f1055fd4e1'
